import { PagedRequestDto } from '@umss/shared/data-access';
import { UserRole } from '../../enums';

export interface AdminProfileSearchDto extends PagedRequestDto {
  role?: UserRole | null;
  department?: string | null;
  isActive?: boolean | null;
}
